<h4 class="page-title">
  <button class="btn btn-outline-blue btn-rounded" (click)="voltar()" *ngIf="!widget && !modoSuporte" style="margin-right: 5px;">
    <i class="fa fa-arrow-left ct-point" ></i>
  </button>
  <i class="fe-user "></i> {{modoSuporte ? 'Modo suporte' : 'Contato'}}
</h4>

<app-notificacoes-promokit></app-notificacoes-promokit>

<div class="modo-suporte-individual" *ngIf="modoSuporte">
  <div class="suporte-contato-card">
    <div class="suporte-contato-topo">
      <div class="modo-suporte-individual__icone">
        <i class="fas fa-headset"></i>
      </div>
      <div>
        <p class="secao-label">Contato pelo número de suporte</p>
        <h5>{{nomeContato || 'Contato sem nome'}}</h5>
        <span class="contato-suporte-telefone">{{telefone}}</span>
      </div>
    </div>

    <div class="assinatura-whatsapp" *ngIf="usuario">
      <input id="assinarMensagensSuporteContato"
             name="assinarMensagensSuporteContato"
             type="checkbox"
             kendoCheckBox
             [(ngModel)]="usuario.assinarMensagens"
             [disabled]="salvandoAssinaturaWhatsapp"
             (ngModelChange)="salveAssinaturaWhatsapp()"/>
      <label class="k-checkbox-label" for="assinarMensagensSuporteContato">
        Assinar mensagens
      </label>
      <span *ngIf="salvandoAssinaturaWhatsapp" class="fa fa-spinner fa-spin"></span>
    </div>

    <div class="alert alert-danger mt-3" *ngIf="suporteContatoErro">
      {{suporteContatoErro}}
    </div>

    <div class="estado-suporte" *ngIf="suporteContatoCarregando">
      Carregando contexto do contato...
    </div>

    <ng-container *ngIf="!suporteContatoCarregando && suporteContatoContexto">
      <div class="atalhos-suporte-empresa" *ngIf="suporteContatoContexto.vinculado">
        <a class="atalho-suporte-link"
           href="https://ajuda.meucardapio.ai"
           target="_blank"
           rel="noopener"
           title="Abrir ajuda do MeuCardapio">
          <i class="fa fa-life-ring"></i>
          Ajuda
        </a>
        <a class="atalho-suporte-link"
           href="https://promokitconsulta.netlify.app/"
           target="_blank"
           rel="noopener"
           title="Abrir manual do suporte">
          <i class="fa fa-search"></i>
          Manual
        </a>
        <a class="atalho-suporte-link"
           href="/admin/manual-modo-suporte"
           target="_blank"
           rel="noopener"
           title="Abrir manual da funcionalidade modo suporte">
          <i class="fa fa-info-circle"></i>
          Modo suporte
        </a>
      </div>

      <div class="suporte-vinculo" *ngIf="suporteContatoContexto.vinculado && !suporteContatoEditando">
        <div>
          <p class="secao-label">Empresa atendida</p>
          <h5>{{suporteContatoContexto.empresaSuporte?.nome}}</h5>
          <span class="contato-suporte-meta">
            {{textoFuncaoContatoSuporte(suporteContatoContexto.contato?.funcao)}}
            <ng-container *ngIf="suporteContatoContexto.usuarioEmpresa?.nome">
              - {{suporteContatoContexto.usuarioEmpresa?.nome}}
            </ng-container>
          </span>
        </div>

        <div class="suporte-vinculo-acoes">
          <button type="button"
                  class="btn btn-outline-primary btn-sm"
                  (click)="abraGrupoEmpresaAtendida()"
                  [disabled]="!suporteContatoContexto.grupoSuporte">
            <i class="fab fa-whatsapp mr-1"></i>
            Abrir grupo
          </button>

          <button type="button" class="btn btn-link btn-sm" (click)="editeVinculoContatoSuporte()">
            Alterar vínculo
          </button>

          <button type="button"
                  class="btn btn-link btn-sm text-danger"
                  (click)="abraDesvincularContatoSuporte()"
                  *ngIf="!suporteContatoExibindoDesvincular">
            Desvincular
          </button>
        </div>
      </div>

      <div class="desvincular-contato-suporte" *ngIf="suporteContatoContexto.vinculado && suporteContatoExibindoDesvincular">
        <label>Justificativa para desvincular</label>
        <textarea class="form-control"
                  rows="3"
                  [(ngModel)]="suporteContatoJustificativaDesvinculo"
                  placeholder="Explique por que este contato será desvinculado da empresa."></textarea>
        <div class="acoes-form-suporte mt-2">
          <button type="button"
                  class="btn btn-link btn-sm"
                  (click)="canceleDesvincularContatoSuporte()"
                  [disabled]="suporteContatoDesvinculando">
            Cancelar
          </button>
          <button type="button"
                  class="btn btn-danger btn-sm"
                  (click)="desvinculeContatoSuporte()"
                  [disabled]="suporteContatoDesvinculando || !suporteContatoJustificativaDesvinculo">
            <i class="fa" [ngClass]="suporteContatoDesvinculando ? 'fa-spinner fa-spin' : 'fa-unlink'"></i>
            Confirmar desvínculo
          </button>
        </div>
      </div>

      <div class="alert alert-warning mt-3" *ngIf="suporteContatoContexto.vinculado && !suporteContatoContexto.grupoSuporte">
        Esta empresa ainda não tem grupo IMPL ou PKT vinculado.
      </div>

      <div class="suporte-form" *ngIf="!suporteContatoContexto.vinculado || suporteContatoEditando">
        <p class="secao-label">Vincular a empresa atendida</p>

        <div class="input-group mb-2">
          <input class="form-control"
                 placeholder="Buscar empresa por nome, domínio ou CNPJ"
                 [(ngModel)]="suporteContatoTermoEmpresa"
                 (ngModelChange)="agendeBuscaEmpresasContatoSuporte()"
                 (keyup.enter)="busqueEmpresasContatoSuporte()">
          <div class="input-group-append">
            <button type="button"
                    class="btn btn-outline-primary"
                    (click)="busqueEmpresasContatoSuporte()"
                    [disabled]="suporteContatoBuscandoEmpresas">
              <i class="fa" [ngClass]="suporteContatoBuscandoEmpresas ? 'fa-spinner fa-spin' : 'fa-search'"></i>
            </button>
          </div>
        </div>

        <div class="lista-empresas-suporte" *ngIf="suporteContatoEmpresas.length > 0">
          <button type="button"
                  class="empresa-suporte-opcao"
                  *ngFor="let empresaItem of suporteContatoEmpresas"
                  [class.selecionada]="suporteContatoEmpresaSelecionada?.id === empresaItem.id"
                  (click)="selecioneEmpresaContatoSuporte(empresaItem)">
            <strong>{{empresaItem.nome}}</strong>
            <span>{{empresaItem.dominio || empresaItem.cnpj || 'Empresa sem domínio'}}</span>
          </button>
        </div>

        <div class="estado-suporte" *ngIf="!suporteContatoBuscandoEmpresas && !suporteContatoBuscouEmpresas && !suporteContatoEmpresaSelecionada">
          Busque a empresa atendida para associar este contato.
        </div>

        <div class="estado-suporte" *ngIf="!suporteContatoBuscandoEmpresas && suporteContatoBuscouEmpresas && suporteContatoEmpresas.length === 0">
          Nenhuma empresa encontrada.
        </div>

        <div class="empresa-selecionada-suporte" *ngIf="suporteContatoEmpresaSelecionada">
          <strong>{{suporteContatoEmpresaSelecionada.nome}}</strong>
          <span>{{suporteContatoEmpresaSelecionada.dominio || suporteContatoEmpresaSelecionada.cnpj}}</span>
        </div>

        <div class="linha-form-suporte">
          <div class="form-group">
            <label>Função na empresa</label>
            <select class="form-control" [(ngModel)]="suporteContatoForm.funcao">
              <option value="PROPRIETARIO">Proprietário</option>
              <option value="EQUIPE">Membro da equipe</option>
              <option value="MARKETING">Marketing</option>
              <option value="OUTRO">Outro</option>
            </select>
          </div>

          <div class="form-group">
            <label>Usuário da empresa</label>
            <select class="form-control"
                    [(ngModel)]="suporteContatoForm.usuarioEmpresaId"
                    [disabled]="!suporteContatoEmpresaSelecionada">
              <option [ngValue]="null">Não vincular</option>
              <option *ngFor="let usuarioEmpresa of suporteContatoUsuariosEmpresa" [ngValue]="usuarioEmpresa.id">
                {{usuarioEmpresa.nome}}
              </option>
            </select>
          </div>
        </div>

        <div class="acoes-form-suporte">
          <button type="button"
                  class="btn btn-link btn-sm"
                  *ngIf="suporteContatoContexto.vinculado"
                  (click)="canceleEdicaoContatoSuporte()">
            Cancelar
          </button>
          <button type="button"
                  class="btn btn-primary btn-sm"
                  (click)="vinculeContatoSuporte()"
                  [disabled]="suporteContatoSalvando || !suporteContatoEmpresaSelecionada">
            <i class="fa" [ngClass]="suporteContatoSalvando ? 'fa-spinner fa-spin' : 'fa-link'"></i>
            Vincular contato
          </button>
        </div>
      </div>

      <app-tickets-suporte
        *ngIf="suporteContatoContexto.vinculado"
        [empresa]="suporteContatoContexto.empresaSuporte"
        [contato]="suporteContatoContexto.contato"
        [grupo]="suporteContatoContexto.grupoSuporte"
        [compacto]="true">
      </app-tickets-suporte>

      <div class="historico-contato-suporte" *ngIf="suporteContatoContexto.historico?.length">
        <p class="secao-label">Histórico de vínculos</p>
        <div class="historico-contato-item" *ngFor="let item of suporteContatoContexto.historico">
          <div class="historico-contato-topo">
            <strong>{{textoAcaoHistoricoContatoSuporte(item.acao)}}</strong>
            <span>{{item.dataCriacao | date:'dd/MM/yyyy HH:mm'}}</span>
          </div>
          <div class="historico-contato-meta">
            {{item.usuarioNome}} - {{item.empresaSuporteNome}}
            <ng-container *ngIf="item.usuarioEmpresaNome">
              - {{item.usuarioEmpresaNome}}
            </ng-container>
          </div>
          <p *ngIf="item.justificativa">{{item.justificativa}}</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="!modoSuporte">

<div style="position: absolute;top: 15px;right: 15px;">
  <button class="btn btn-secondary btn-sm mr-1" (click)="exibirTodosLogs();" kendoTooltip title="Ver TODOS os logs do sistema (debug)">
    <i class="fas fa-stethoscope"></i>
  </button>
  <button class="btn btn-blue" (click)="recarregue();" kendoTooltip title="Recarregar o cardápio e forçar envio das mensagens."><i class="fas fa-sync-alt"></i></button>
</div>

<app-gerenciador-envio-campanha></app-gerenciador-envio-campanha>

<!-- Seção para exibir relatórios e diagnósticos diretamente na tela -->
<div class="card shadow-sm mt-3" *ngIf="exibirRelatorioNaTela">
  <div class="card-header bg-info text-white d-flex justify-content-between align-items-center py-2">
    <h6 class="mb-0 font-weight-bold">
      <i class="fas fa-terminal mr-2"></i>
      {{tituloRelatorio}}
    </h6>
    <button class="btn btn-sm btn-outline-light rounded-circle p-1" (click)="fecharRelatorio()" kendoTooltip title="Fechar relatório" style="width: 28px; height: 28px;">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Mostrar ListView quando há logs -->
  <div class="card-body p-0" *ngIf="logsListView.length > 0">
    <!-- Barra de estatísticas -->
    <div class="p-3 border-bottom" style="background: #ffffff;">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <span class="mr-3"><strong>Total:</strong> {{totalLogs}} logs</span>
            <span class="estatistica-badge sucesso" *ngIf="estatisticas.sucessos > 0">
              ✅ {{estatisticas.sucessos}}
            </span>
            <span class="estatistica-badge erro" *ngIf="estatisticas.erros > 0">
              ❌ {{estatisticas.erros}}
            </span>
            <span class="estatistica-badge aviso" *ngIf="estatisticas.avisos > 0">
              ⚠️ {{estatisticas.avisos}}
            </span>
            <span class="estatistica-badge processamento" *ngIf="estatisticas.processamentos > 0">
              🔄 {{estatisticas.processamentos}}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex justify-content-end">
            <button class="btn btn-sm btn-outline-primary" (click)="limparFiltros()" *ngIf="filtroTipo !== 'TODOS' || filtroCategoria !== 'TODAS' || textoBusca">
              <i class="fas fa-times mr-1"></i> Limpar Filtros
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Barra de filtros -->
    <div class="p-3 border-bottom" style="background: #fafbfc;">
      <div class="row">
        <div class="col-md-4">
          <label class="small text-muted mb-1">Buscar:</label>
          <input type="text" class="form-control form-control-sm" placeholder="Buscar nos logs..."
                 [(ngModel)]="textoBusca" (ngModelChange)="filtrarLogs()">
        </div>
        <div class="col-md-4">
          <label class="small text-muted mb-1">Tipo:</label>
          <select class="form-control form-control-sm" [(ngModel)]="filtroTipo" (ngModelChange)="filtrarLogs()">
            <option value="TODOS">Todos</option>
            <option value="SUCCESS">✅ Sucesso</option>
            <option value="ERROR">❌ Erro</option>
            <option value="WARNING">⚠️ Aviso</option>
            <option value="INFO">🔵 Info</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="small text-muted mb-1">Categoria:</label>
          <select class="form-control form-control-sm" [(ngModel)]="filtroCategoria" (ngModelChange)="filtrarLogs()">
            <option value="TODAS">Todas</option>
            <option value="PROCESSAMENTO">⚙️ Processamento</option>
            <option value="VALIDACAO">🔍 Validação</option>
            <option value="ENVIO">📤 Envio</option>
            <option value="SISTEMA">🖥️ Sistema</option>
          </select>
        </div>
      </div>
    </div>

    <!-- ListView -->
    <div class="relatorio-listview" style="max-height: 500px; overflow-y: auto; background: #fafbfc;">
      <!-- Mostrar ListView quando há logs -->
      <kendo-listview [data]="logsListViewFiltrados" [height]="500" *ngIf="logsListViewFiltrados.length > 0">
        <ng-template kendoListViewItemTemplate let-dataItem>
          <div class="log-item-card" [ngClass]="dataItem.cssClass" (click)="toggleDetalhes(dataItem)">
            <!-- Texto da mensagem no topo com destaque -->
            <div class="log-texto-mensagem-destaque mb-3">
              <div class="d-flex justify-content-between align-items-start">
                <div class="texto-mensagem-conteudo-principal flex-grow-1">
                  <span class="texto-icone">📝</span>
                  <span *ngIf="dataItem.textoMensagem" class="texto-conteudo">"{{dataItem.textoMensagem}}"</span>
                  <span *ngIf="!dataItem.textoMensagem" class="texto-conteudo text-muted font-italic">
                    <span *ngIf="dataItem.categoria === 'PROCESSAMENTO'">(processando...)</span>
                    <span *ngIf="dataItem.categoria !== 'PROCESSAMENTO'">(sem texto de mensagem)</span>
                  </span>
                </div>
                <div class="log-time text-muted text-nowrap ml-2">
                  <small>{{dataItem.timestamp | date:'HH:mm:ss.SSS'}} ({{dataItem.tempoRelativo}})</small>
                </div>
              </div>
              <div class="mt-1" *ngIf="dataItem.tipoMensagem">
                <small class="text-muted">
                  <i class="fas fa-tag mr-1"></i>
                  Tipo: <strong>{{dataItem.tipoMensagem}}</strong>
                </small>
              </div>
            </div>

            <div class="log-item-header">
              <div class="d-flex justify-content-between align-items-start">
                <div class="log-item-info">
                  <span class="log-icon mr-2">{{dataItem.icone}}</span>
                  <span class="log-categoria mr-2">{{dataItem.iconeCategoria}} {{dataItem.categoria}}</span>
                </div>
                <div class="log-item-pessoa text-right">
                  <span class="log-nome">👤 {{dataItem.nome}}</span>
                  <span class="log-telefone text-muted ml-2" *ngIf="dataItem.telefone">📱 {{dataItem.telefone}}</span>
                </div>
              </div>
            </div>

            <div class="log-item-body mt-2">
              <div class="log-mensagem">
                💬 {{dataItem.mensagem}}
              </div>

              <div class="log-detalhes mt-2" *ngIf="dataItem.detalhesFormatados && dataItem.expanded">
                <pre class="mb-0">{{dataItem.detalhesFormatados}}</pre>
              </div>

              <div class="text-center mt-2" *ngIf="dataItem.detalhesFormatados">
                <button class="btn btn-sm btn-link p-0">
                  <i class="fas" [ngClass]="dataItem.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  {{dataItem.expanded ? 'Menos detalhes' : 'Mais detalhes'}}
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-listview>

      <!-- Mensagem quando não há logs após filtro - DENTRO da div relatorio-listview -->
      <div class="empty-state-container" *ngIf="logsListViewFiltrados.length === 0 && logsListView.length > 0">
        <div class="empty-state-content">
          <i class="fas fa-search fa-3x mb-3"></i>
          <h5>Nenhum log encontrado</h5>
          <p class="text-muted">Os filtros aplicados não retornaram resultados.</p>
          <button class="btn btn-sm btn-primary" (click)="limparFiltros()">
            <i class="fas fa-times mr-1"></i> Limpar Filtros
          </button>
        </div>
      </div>

      <!-- Empty state quando não há logs no sistema -->
      <div class="empty-state-container" *ngIf="logsListView.length === 0 && !conteudoRelatorioFormatado">
        <div class="empty-state-content">
          <i class="fas fa-inbox fa-3x mb-3"></i>
          <h5>Nenhum log disponível</h5>
          <p class="text-muted">Ainda não há logs para exibir.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Mostrar conteúdo HTML quando não há logs (fallback) -->
  <div class="card-body p-0" *ngIf="logsListView.length === 0 && conteudoRelatorioFormatado">
    <div class="relatorio-container" style="background: #1e1e1e; color: #f8f9fa; padding: 15px; max-height: 450px; overflow-y: auto; border-left: 4px solid #17a2b8;">
      <div class="log-content" [innerHTML]="conteudoRelatorioFormatado"></div>
    </div>
  </div>

  <div class="card-footer border-top" style="background: #ffffff !important; border-color: #e9ecef !important;">
    <div class="d-flex justify-content-between align-items-center">
      <small class="text-muted d-flex align-items-center">
        <i class="fas fa-clock mr-1" style="color: #6c757d;"></i>
        Gerado em {{dataGeracaoRelatorio}}
      </small>
      <div>
        <button class="btn btn-sm btn-outline-secondary mr-2" (click)="copiarRelatorio()" kendoTooltip title="Copiar para área de transferência">
          <i class="fas fa-copy mr-1"></i> Copiar
        </button>
        <button class="btn btn-sm btn-outline-warning mr-2" (click)="limparLogs()" kendoTooltip title="Limpar todos os logs">
          <i class="fas fa-trash mr-1"></i> Limpar Log
        </button>
        <button class="btn btn-sm btn-outline-danger" (click)="fecharRelatorio()">
          <i class="fas fa-times mr-1"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="mb-2" *ngIf="dev">
  <div class="form-group mt-2">
    <label>Enviar mensagem Teste Chatbot:</label>
    <input type="text" class="form-control" (keyup.enter)="digitouMensagemBot($event)"/>
  </div>
</div>

<div class="k-i-loading ml-1 mr-1 mt-3" style="font-size: 50px; padding-bottom: 20px" *ngIf="!carregou || !verificouLead" ></div>

<!-- Número pessoal pareado é a Mia Gestor: o contato é um lead, e a página é só dele. -->
<app-lead-contato-gestor *ngIf="carregou && modoLead" [telefone]="telefoneDoContato" [nome]="contato?.nome || nomeContato"></app-lead-contato-gestor>

<!-- Grupo em comum PKT/IMPL: já é cliente do MeuCardápio; a página mostra a loja dele, não a ficha de consumidor. -->
<section class="cliente-gestor" *ngIf="carregou && verificouLead && grupoCliente && !modoSuporte" aria-label="Cliente MeuCardápio">
  <header class="cliente-gestor__cabeca">
    <span class="cliente-gestor__avatar" aria-hidden="true">{{ inicialDoCliente }}</span>
    <div class="cliente-gestor__identidade">
      <h3>{{ contato?.nome || nomeContato || 'Cliente' }}</h3>
      <span class="cliente-gestor__num">{{ telefoneDoClienteFormatado }}</span>
    </div>
    <span class="cliente-gestor__selo"><i class="fas fa-check" aria-hidden="true"></i>Cliente</span>
  </header>

  <div class="cliente-gestor__faixa" role="status">
    <span class="cliente-gestor__faixa-icone" aria-hidden="true"><i class="fas fa-handshake"></i></span>
    <div>
      <strong>Já é cliente MeuCardápio</strong>
      <p>Está no grupo <b>{{ grupoCliente }}</b> com a gente. A Mia Gestor não vende para quem já é cliente.</p>
    </div>
  </div>

  <h4 class="cliente-gestor__secao">Loja</h4>
  <div class="cliente-gestor__loja cliente-gestor__loja--carregando" *ngIf="clienteDoGrupo.carregando" aria-hidden="true">
    <span class="cliente-gestor__loja-icone"></span><div><i class="barra barra--larga"></i><i class="barra"></i></div>
  </div>
  <ng-container *ngIf="!clienteDoGrupo.carregando">
    <ng-container *ngIf="clienteDoGrupo.loja as loja; else semLoja">
      <div class="cliente-gestor__loja">
        <span class="cliente-gestor__loja-icone" aria-hidden="true"><i class="fas fa-store"></i></span>
        <div class="cliente-gestor__loja-nome">
          <strong>{{ loja.nome }}</strong>
          <span *ngIf="loja.dominio">{{ loja.dominio }}.meucardapio.ai</span>
        </div>
      </div>
      <dl class="cliente-gestor__dados" *ngIf="loja.cnpj || loja.email || loja.whatsapp">
        <div *ngIf="loja.cnpj"><dt>CNPJ</dt><dd>{{ loja.cnpj }}</dd></div>
        <div *ngIf="loja.whatsapp"><dt>WhatsApp da loja</dt><dd>{{ loja.whatsapp }}</dd></div>
        <div *ngIf="loja.email" class="cliente-gestor__dados--largo"><dt>E-mail</dt><dd>{{ loja.email }}</dd></div>
      </dl>
    </ng-container>
    <ng-template #semLoja>
      <p class="cliente-gestor__vazio">
        <i class="fas" [ngClass]="clienteDoGrupo.erro ? 'fa-exclamation-circle' : 'fa-link'" aria-hidden="true"></i>
        {{ clienteDoGrupo.erro ? 'Não deu para consultar a loja deste grupo agora.' : 'O grupo ainda não tem loja vinculada. Vincule pela tela do grupo.' }}
      </p>
    </ng-template>
  </ng-container>

  <div class="cliente-gestor__acoes">
    <button type="button" class="cliente-gestor__botao cliente-gestor__botao--primario" *ngIf="grupoClienteId" (click)="abraGrupoDoCliente()">
      <i class="fas fa-headset" aria-hidden="true"></i>Abrir o grupo de suporte
    </button>
    <a class="cliente-gestor__botao" *ngIf="linkAdminDoCliente" [href]="linkAdminDoCliente" target="_blank" rel="noopener">
      <i class="fas fa-external-link-alt" aria-hidden="true"></i>Abrir o painel da loja
    </a>
  </div>
</section>

<ng-container *ngIf="carregou && verificouLead && !modoLead && !(grupoCliente && !modoSuporte)">
<div class="row"  [hidden]="contato == null">
  <div class="col-12">
    <info-contato [contato]="contato" [exibirUltimaVisita]="true" [atendente]="atendente" [statusMia]="statusMia" [autoriaPendenteV4]="autoriaPendenteV4"
                  [desativarParaSempre]="desativarParaSempre"
                  [inserirtTag]="true" [empresa]="empresa" [exibirEndereco]="true" [limiteEndereco]="2">
    </info-contato>
    <app-resumo-crm-contato *ngIf="contato" [contato]="contato"></app-resumo-crm-contato>
    <app-perfil-cliente *ngIf="contato" [contato]="contato" [compacto]="true"></app-perfil-cliente>
    <app-carrinho-mia *ngIf="contato" [contato]="contato" [empresa]="empresa"></app-carrinho-mia>
  </div>

  <div class="col-12 mt-2">
    <div class="alert alert-success mb-0" role="alert" *ngIf="msg">
      <i class="mdi mdi-check-all mr-2"></i> {{msg}}  <i class="fa fa-print fa-lg cpointer ml-1" *ngIf="novoPedido.guid"
                                                         (click)="imprimaPedido(this.novoPedido)"> </i>
    </div>
  </div>

  <div class="col-12 mb-3" *ngIf="contato  && (contato.telefone || contato.id)">
    <acoes-modulos [contato]="contato" (salvouContato)="salveContato($event)"></acoes-modulos>
  </div>

  <div class="col-12">
    <info-pedidos [contato]="contato"  [empresa]="empresa"></info-pedidos>
  </div>

  <div class="col-12 ">
    <info-fidelidade *ngIf="contato" [cartoes]="contato.cartoes" [empresa]="empresa"></info-fidelidade>
  </div>

  <div class="col-12">
    <app-historico-modulos [contato]="contato" [empresa]="empresa" ></app-historico-modulos>
  </div>
</div>

<div  [hidden]="!carregou || contato != null">
  <div class="row">
    <div class="col">
      <info-contato [contato]="contatoPorDados" [atendente]="atendente" [statusMia]="statusMia" [autoriaPendenteV4]="autoriaPendenteV4"
                    [exibirUltimaVisita]="true" [empresa]="empresa" [desativarParaSempre]="desativarParaSempre"></info-contato>
      <app-perfil-cliente *ngIf="carregou && !contato" [contato]="contatoPorDados" [compacto]="true"></app-perfil-cliente>
      <app-carrinho-mia *ngIf="contatoPorDados" [contato]="contatoPorDados" [empresa]="empresa"></app-carrinho-mia>
      <acoes-modulos [contato]="contatoPorDados" [novoContato]="true" (salvouContato)="salveContato($event)"></acoes-modulos>
    </div>
  </div>
</div>
</ng-container>

</ng-container>
